import React from "react";

class ListenClickOutside extends React.Component {
  constructor() {
    super();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    // Add timeout in order to defer the first click handler
    setTimeout(
      () => window.addEventListener("click", this.handleOutsideClick),
      0
    );
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.handleOutsideClick);
  }

  componentDidUpdate() {
    window.removeEventListener("click", this.handleOutsideClick);
    setTimeout(
      () => window.addEventListener("click", this.handleOutsideClick),
      0
    );
  }

  handleOutsideClick(event) {
    if (this.container && !this.container.contains(event.target)) {
      this.props.onClickOutside(this.props);
    }
  }

  render() {
    return this.props.children({ setRef: (ref) => (this.container = ref) });
  }
}

export default ListenClickOutside;
